import React from "react";
import { NavData, NavItem } from "./NavItem";

export interface FullNavDropdownProps {
  links: NavData[];
}

const FullNavDropdown = ({ links }: FullNavDropdownProps) => {
  const col1 = links[0];
  const navLinkLists = links.slice(1);
  const middle = Math.floor(navLinkLists.length / 2);
  const col2 = navLinkLists.slice(0, middle);
  const col3 = navLinkLists.slice(middle);
  return (
    <div className="absolute left-0 top-20 z-50 -mt-0.5 flex w-full justify-center bg-white py-8 shadow">
      <div className="flex w-full max-w-7xl justify-center space-x-14 px-14">
        <div className="basis-3/5">
          {col1.type === "submenu" ? (
            <NavItem {...col1} onSubmenuClick={() => {}} />
          ) : (
            <NavItem {...col1} />
          )}
        </div>
        <div className="flex basis-1/5 flex-col space-y-9">
          {col2.map((navItem, index) => {
            return navItem.type === "submenu" ? (
              <NavItem key={index} {...navItem} onSubmenuClick={() => {}} />
            ) : (
              <NavItem key={index} {...navItem} />
            );
          })}
        </div>
        <div className="flex basis-1/5 flex-col space-y-9">
          {col3.map((navItem, index) => {
            return navItem.type === "submenu" ? (
              <NavItem key={index} {...navItem} onSubmenuClick={() => {}} />
            ) : (
              <NavItem key={index} {...navItem} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export { FullNavDropdown };
